export const isPixiStandAlone = false
export const basePath = '/assets/pixi/plinko/'

export const path = {
  imagePath: basePath + 'images/',
  spriteSheetsPath: basePath + 'spriteSheets/',
  fontPath: basePath + 'fonts/'
}

export const config = {
  maxLines: 16,
  originalWidth: 1080,
  originalHeight: 1080,
  topMargin: 580,
  rows: 8,
  pegs: {
    spacing: {
      width: 80,
      height: 80
    },
    pegsWidth: 24,
    shine: {
      animationSpeed: 1.3
    }
  },
  ball: {
    path: [0, 1, 0, 1, 0, 1, 0, 1],
    currentRow: 0,
    animationSpeed: 0.8, // 0.9,
    scaleForAnimation: [1.9, 1.7, 1.52, 1.376, 1.26, 1.16, 1.054, 1, 0.93],
    colorOptions: [0xffffff, 0xff0083, 0x04b2ac, 0xff9c2b],
    bounceEffect: {
      //                 8    9    10     11     12     13     14    15    16
      scaleFactorScale: [1, 0.99, 0.89, 0.8, 0.79, 0.76, 0.74, 0.72, 0.56],
      scaleFactorX: [1, 0.888, 0.78, 0.73, 0.667, 0.65, 0.59, 0.542, 0.52],
      scaleFactorY: [1.01, 0.888, 0.796, 0.72, 0.655, 0.6, 0.555, 0.517, 0.48]
    }
  },
  box: {
    boxSpeed: 2,
    height: 65,
    width: 140,
    heightScale: 0, // 75
    widthScale: 5.2
  },
  pinInFirstLine: 3,
  bgAssets: {
    speed: 0.06
  },
  progress: {
    bar: {
      backgroundColor: '#e55039',
      border: 4,
      borderColor: '#FFFFFF',
      fillColor: '#4cd137',
      height: 30,
      radius: 25,
      width: 550
    },
    text: {
      visible: true,
      fill: 0xffffff,
      fontSize: 30
    }
  },
  multiplierBoxesTints: [
    [2, 2, 1, 2, 2], // 8 lines
    [2, 2, 2, 2, 2], // 9
    [3, 2, 1, 2, 3], // 10
    [3, 2, 2, 2, 3], // 11
    [4, 2, 1, 2, 4], // 12
    [4, 2, 2, 2, 4], // 13
    [4, 3, 1, 3, 4], // 14
    [4, 3, 2, 3, 4], // 15
    [5, 3, 1, 3, 5] // 16
  ]
}

export const gameDisplaySettings = {
  size: 1200,
  x: config.originalWidth / 2,
  y: config.originalHeight / 2 - 30
}
